import { useState, useEffect } from 'react';
import api from './api';

// Fallback defaults (in case API not available yet)
const FALLBACK = [
  { key: 'draft', label: 'Szkic', color: '#6b7280' },
  { key: 'needs_info', label: 'Do uzupełnienia', color: '#f97316' },
  { key: 'pending', label: 'Do weryfikacji', color: '#3b82f6' },
  { key: 'approved', label: 'Zatwierdzona', color: '#22c55e' },
  { key: 'needs_update', label: 'Do aktualizacji', color: '#ef4444' },
  { key: 'withdrawn', label: 'Wycofana', color: '#374151' },
];

let cachedStatuses = null;
let cacheTime = 0;
const CACHE_TTL = 60000; // 1 minute

export async function fetchStatuses() {
  const now = Date.now();
  if (cachedStatuses && now - cacheTime < CACHE_TTL) return cachedStatuses;
  try {
    const r = await api.get('/settings/statuses');
    cachedStatuses = r.data;
    cacheTime = now;
    return cachedStatuses;
  } catch {
    return FALLBACK;
  }
}

export function invalidateStatusCache() { cachedStatuses = null; cacheTime = 0; }

export function useStatuses() {
  const [statuses, setStatuses] = useState(cachedStatuses || FALLBACK);

  useEffect(() => {
    fetchStatuses().then(s => setStatuses(s));
  }, []);

  const labelMap = Object.fromEntries(statuses.map(s => [s.key, s.label]));
  const colorMap = Object.fromEntries(statuses.map(s => [s.key, s.color]));

  return { statuses, labelMap, colorMap };
}
